import { Question } from "@zp-models/question";

export const AANVRAAG_STEPS: Record<string, Question> = {
  step1: {
    id: "step1",
    title: "",
    titleForReceipt: "",
    subTitle: "AANVRAGEN_STEP.SUBTITLE",
    type: "form",
    fields: [
      {
        name: "firstName",
        type: "input",
        label: "AANVRAGEN_STEP.FIELDS.FIRST_NAME.LABEL",
        required: false,
      },
      {
        name: "lastName",
        type: "input",
        label: "AANVRAGEN_STEP.FIELDS.LAST_NAME.LABEL",
        required: false,
      },
      {
        name: "email",
        type: "input",
        label: "AANVRAGEN_STEP.FIELDS.EMAIL.LABEL",
        subLabel: "",
        required: false,
      },
      {
        name: "phone_number",
        type: "input",
        label: "AANVRAGEN_STEP.FIELDS.PHONE_NUMBER.LABEL",
        subLabel: "",
        required: false,
      },
      {
        name: "organisation_name",
        type: "input",
        label: "AANVRAGEN_STEP.FIELDS.ORGANISATION_NAME.LABEL",
        subLabel: "",
        required: false,
      },
      {
        name: "number_of_employees",
        type: "input",
        label: "AANVRAGEN_STEP.FIELDS.NUMBER_OF_EMPLOYEES.LABEL",
        subLabel: "AANVRAGEN_STEP.FIELDS.NUMBER_OF_EMPLOYEES.SUB_LABEL",
        required: false,
      },
      {
        name: "is_customer",
        label: "AANVRAGEN_STEP.FIELDS.IS_CUSTOMER.LABEL",
        type: "radio",
        options: [
          {
            value: "yes",
            label: "AANVRAGEN_STEP.FIELDS.IS_CUSTOMER.OPTIONS.YES.LABEL",
            receiptLabel: "AANVRAGEN_STEP.FIELDS.OPTIONS.YES.RECEIPT_LABEL",
          },
          {
            value: "no",
            label: "AANVRAGEN_STEP.FIELDS.IS_CUSTOMER.OPTIONS.NO.LABEL",
            receiptLabel: "AANVRAGEN_STEP.FIELDS.OPTIONS.NO.RECEIPT_LABEL",
          },
        ],
      },
    ],
    button: {
      label: "AANVRAGEN_STEP.STEP.BUTTON.LABEL",
      variant: "AANVRAGEN_STEP.STEP.BUTTON.VARIANT",
    },
  },
};
